var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import './../../external/@lit/reactive-element/reactive-element.js';
import { html as y } from './../../external/lit-html/lit-html.js';
import { LitElement as s } from './../../external/lit-element/lit-element.js';
import DropdownCss from "./DropdownCss.js";
import ModalDialog from "../ModalDialog/ModalDialog.js";
import "../Popup/Popup.js";
class Dropdown extends s {
  constructor() {
    super();
    __publicField(this, "validate", () => {
      if (this.readonly) {
        return true;
      }
      const valid = !this.required || !isEmpty(this.value);
      if (valid) {
        this.classList.remove("error");
        this.message = "";
      } else {
        this.classList.add("error");
        this.message = translateText(this._translations(), "empty");
      }
      this.requestUpdate();
      return valid;
    });
    __publicField(this, "getValue", () => this.value);
    __publicField(this, "getValueText", () => this.valueText);
    __publicField(this, "hasChanges", () => this.valueChanged);
    __publicField(this, "_hide", (e) => {
      if (!e.composedPath().includes(this)) {
        this._closeOptions();
      }
    });
    __publicField(this, "_setDropdownPosition", () => {
      const fieldRect = this.shadowRoot.querySelector(".field").getBoundingClientRect();
      const items = this.shadowRoot.querySelector(".options > ul");
      items.style.width = `${fieldRect.width}px`;
      items.style.top = `${this._calculatePosition(fieldRect, items)}px`;
      items.style.left = `${fieldRect.left}px`;
    });
    __publicField(this, "_calculatePosition", (fieldRect, items) => {
      const nItems = this.itemsFiltered ? this.itemsFiltered.length : 0;
      const itemHeight = items.getBoundingClientRect().height > 0 ? items.getBoundingClientRect().height : Math.min(300, nItems * 50);
      const maxYPos = window.innerHeight - itemHeight;
      return fieldRect.bottom < window.innerHeight && fieldRect.bottom > maxYPos ? maxYPos : fieldRect.bottom;
    });
    __publicField(this, "_updateFocus", (func) => {
      if (this.optionsOpened) {
        this.focusedValue = func();
        this._focusValue(true);
      } else {
        this.focusedValue = this.value;
        this.focusedValue = func();
        if (this.focusedValue !== this.value) {
          this._change(this.focusedValue, this._focusedName());
        }
      }
    });
    __publicField(this, "_focusedName", () => this._selectedName(this.focusedValue));
    __publicField(this, "_indexOfValue", () => {
      var _a;
      return (_a = this.itemsFiltered) == null ? void 0 : _a.findIndex((item) => item.value === this.focusedValue);
    });
    __publicField(this, "_nextValue", () => {
      var _a;
      return (_a = this.itemsFiltered) == null ? void 0 : _a[Math.min(this._indexOfValue() + 1, this.itemsFiltered.length - 1)].value;
    });
    __publicField(this, "_previousValue", () => {
      var _a;
      const index = this._indexOfValue(this.focusedValue);
      if (this.placeholder && index <= 0) {
        return "";
      }
      return (_a = this.itemsFiltered) == null ? void 0 : _a[Math.max(index - 1, 0)].value;
    });
    __publicField(this, "_focusValue", (scrollIntoView = false) => {
      this.shadowRoot.querySelectorAll(`li.focus`).forEach((item) => item.classList.remove("focus"));
      let element;
      if (isEmpty(this.focusedValue)) {
        if (this.placeholder) {
          element = this.shadowRoot.querySelector(`li[value]`);
        }
      } else {
        element = this.shadowRoot.querySelector(`li[value="${this.focusedValue}"]`);
      }
      element == null ? void 0 : element.classList.add("focus");
      if (scrollIntoView) {
        this._scrollTo(element);
      }
    });
    __publicField(this, "_scrollTo", (element) => {
      if (!element) {
        return;
      }
      const options = this.shadowRoot.querySelector(".options > ul");
      if (options.clientHeight === options.scrollHeight) {
        return;
      }
      const optionsTop = options.scrollTop;
      const optionsBottom = optionsTop + options.clientHeight;
      const elementTop = element.offsetTop;
      const elementBottom = elementTop + element.clientHeight;
      if (elementTop < optionsTop) {
        options.scrollTop -= optionsTop - elementTop;
      } else if (elementBottom > optionsBottom) {
        options.scrollTop += elementBottom - optionsBottom;
      }
    });
    this.optionsOpened = false;
    this.message = "";
    this.valueChanged = false;
    this.focusedValue = null;
    this.itemsFiltered = [];
  }
  static get styles() {
    return [DropdownCss];
  }
  static get properties() {
    return {
      label: { type: String },
      helpText: { attribute: "help-text", type: String | Function },
      value: { type: String | Number },
      valueText: { type: String },
      items: { type: Array },
      i18n: { type: Array },
      placeholder: { type: String },
      placeholderEmpty: { attribute: "placeholder-empty", type: String },
      inline: { type: Boolean },
      disabled: { type: Boolean },
      required: { type: Boolean },
      readonly: { type: Boolean },
      title: { type: String }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this.focusedValue = this.value;
    this.itemsFiltered = this.items;
  }
  updated(changedProperties) {
    const updatedProperties = changedProperties.has("items") || changedProperties.has("required") || changedProperties.has("value");
    const shouldCheck = this.valueChanged || !!this.value;
    if (shouldCheck && updatedProperties) {
      this.requestUpdate();
      this.updateComplete.then((_) => this.validate());
    }
  }
  render() {
    return this.readonly ? this.renderReadonly() : this.renderComponent();
  }
  renderComponent() {
    var _a;
    const displayedText = this.optionsOpened ? "" : this._selectedName();
    const placeholder = this.optionsOpened ? this._selectedName() : this.placeholder;
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="${this.inline ? "inline" : ""}">
        <div class="label-wrapper" @click="${() => this._toggleSelect()}">
          <label for="isceco-dropdown">
            ${this.label}
          </label>
          ${this.renderInfo()}
        </div>
        <div class="select-container">
          <div class="dropdown ${this.optionsOpened ? "open" : "closed"} ${this.disabled ? "disabled" : ""}">
            <input type="text"
                   class="field"
                   title="${(_a = this.title) != null ? _a : " "}"
                   .value="${displayedText}"
                   placeholder="${placeholder}"
                   ?disabled="${this.disabled}"
                   @click="${() => this._toggleSelect()}"
                   @keydown="${(e) => this._handleKeydown(e)}"
                   @keyup="${(e) => this._handleKeyup(e)}"/>
            ${this._renderArrowOrClear()}
            <div class="options">
              <ul>${this._renderSelectOptions()}</ul>
            </div>
          </div>
        </div>
      </div>
      <p id="message">
        <i class="exclamation triangle icon"></i>
        ${this.message}
      </p>
    `;
  }
  renderReadonly() {
    var _a;
    const selectedItems = (_a = this.items) == null ? void 0 : _a.filter((x) => x.value === this.value);
    const selectedItem = selectedItems.length > 0 ? selectedItems[0].name : "";
    let name = this._getOptionName(selectedItem);
    if (isEmpty(name) && this.placeholderEmpty) {
      name = this.placeholderEmpty;
    }
    return y`
      <style>@import '${iscecoWidgetLibrary.iconCss}'</style>
      <div class="readonly ${this.inline ? "inline" : ""}">
        <div class="label-wrapper">
          <span>${this.label}</span>
          ${this.renderInfo()}
        </div>
        <p>
          ${name}
        </p>
      </div>
    `;
  }
  renderInfo() {
    if (isEmpty(this.helpText)) {
      return y``;
    } else {
      const helpText = this.helpText instanceof Function ? this.helpText() : this.helpText;
      return y`
        <isceco-popup direction="right">
          <i slot="wrapper" class="info circle icon"></i>
          <div slot="content">${helpText}</div>
        </isceco-popup>
      `;
    }
  }
  _change(value, name) {
    this.value = value != null ? value : "";
    this.valueText = name != null ? name : "";
    this.valueChanged = true;
    const valid = this.validate();
    send("change", {
      valid,
      value: this.value,
      name: this.valueText
    }, this);
    this._closeOptions();
  }
  _toggleSelect() {
    if (!this.disabled) {
      if (this.optionsOpened) {
        this._closeOptions();
      } else {
        this._openOptions();
      }
    }
  }
  _openOptions() {
    if (this.optionsOpened) {
      return;
    }
    this.shadowRoot.querySelector("input.field").focus();
    this.optionsOpened = true;
    this._setDropdownPosition();
    this.focusedValue = this.value;
    this.itemsFiltered = this.items;
    this._focusValue(true);
    window.addEventListener("click", this._hide);
    window.addEventListener("scroll", this._setDropdownPosition);
    window.addEventListener("resize", this._setDropdownPosition);
    window.addEventListener(ModalDialog.EVENT_KEYS.SCROLL, this._setDropdownPosition);
    this.requestUpdate();
  }
  _closeOptions() {
    if (!this.optionsOpened) {
      return;
    }
    this.optionsOpened = false;
    window.removeEventListener("click", this._hide);
    window.removeEventListener("scroll", this._setDropdownPosition);
    window.removeEventListener("resize", this._setDropdownPosition);
    window.removeEventListener(ModalDialog.EVENT_KEYS.SCROLL, this._setDropdownPosition);
    this.requestUpdate();
  }
  _selectedName(value = this.value) {
    var _a;
    return isEmpty(value) ? "" : this._getOptionName((_a = this.items) == null ? void 0 : _a.find((option) => option.value.toString() === value.toString()).name);
  }
  _renderArrowOrClear() {
    if (this.value && !this.required) {
      return y`
        <div class="field-icon clear" @click="${() => this._change("", "")}">
          <i class="icon times circle"></i>
        </div>
      `;
    }
    return y`
      <div class="field-icon arrow">
        <i class="icon angle down"></i>
      </div>
    `;
  }
  _renderSelectOptions() {
    var _a;
    const options = [];
    if (this.placeholder !== void 0) {
      options.push(y`
        <li value="" @click="${() => this._change("", this.placeholder)}">${this.placeholder}</li>
      `);
    }
    (_a = this.itemsFiltered) == null ? void 0 : _a.forEach((option) => {
      const name = this._getOptionName(option.name);
      options.push(y`
        <li title="${name}"
            value="${option.value}"
            @click="${() => this._change(option.value, name)}"
            @mouseenter="${() => {
        this.focusedValue = option.value;
        this._focusValue();
      }}"
        >
          ${name}
        </li>
      `);
    });
    return options;
  }
  _getOptionName(key) {
    return this.i18n ? this.i18n.translate(key) : key;
  }
  _translations() {
    return {
      de: {
        empty: "Wert darf nicht leer gelassen werden."
      },
      fr: {
        empty: "La valeur ne doit pas \xEAtre laiss\xE9e vide."
      },
      it: {
        empty: "Il valore non deve essere lasciato vuoto."
      },
      en: {
        empty: "Value must not be left empty."
      }
    };
  }
  _handleKeydown(e) {
    switch (e.code) {
      case "Escape":
        e.preventDefault();
        this._closeOptions();
        return;
      case "Tab":
        if (this.optionsOpened) {
          this._change(this.focusedValue, this._focusedName());
        }
        return;
      case "Enter":
        e.preventDefault();
        if (this.optionsOpened) {
          this._change(this.focusedValue, this._focusedName());
        } else {
          this._openOptions();
        }
        return;
      case "ArrowDown":
        e.preventDefault();
        this._updateFocus(this._nextValue);
        return;
      case "ArrowUp":
        e.preventDefault();
        this._updateFocus(this._previousValue);
        return;
    }
    if (!this.optionsOpened) {
      e.preventDefault();
      this._openOptions();
    }
  }
  _handleKeyup(e) {
    if (["Escape", "Tab", "Enter", "ArrowDown", "ArrowUp"].includes(e.code)) {
      return;
    }
    this.itemsFiltered = this.items.filter(({ name }) => name.toLowerCase().includes(e.target.value.toLowerCase()));
    this.requestUpdate();
    this.updateComplete.then((_) => {
      if (this.itemsFiltered && this.itemsFiltered.length > 0 && this._indexOfValue() < 0) {
        this.focusedValue = this.itemsFiltered[0].value;
        this._focusValue(true);
      }
    });
  }
}
customElements.define("isceco-dropdown", Dropdown);
export { Dropdown as default };
